<template>
  <el-dialog
    width="500px"
    :destroy-on-close="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    :before-close="handleDialogClose"
    :title="dialogTitle"
    center
    custom-class="messageProp d2-p-0"
    :visible.sync="dialogShow"
  >
    <div class="axj-dialog">
      <div class="message">
        {{dialogMessage}}
      </div>
      <div class="handle">
        <div class="handleButton" v-for="x in buttonData">
          <el-button plain round size="mini" :type="x.type" @click="handleButtonClick(x.key)">{{x.label}}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'axj-message-prop',
  props:{
    dialogShow:{
      type:Boolean,
      default:false
    },
    buttonData:{
      type:Array,
      default: ()=>{
        return [
          {
            "label":"确定",
            "key":"yes",
            "type":undefined
          },
          {
            "label":"去注册",
            "key":"register",
            "type":"primary"
          }
        ]
      }
    },
    dialogMessage:{
      type:String,
      default:"请先登录后再进行操作！"
    },
    dialogTitle:{
      type:String,
      default:"提示"
    },
    handleFunc:{
      type:Function,
      default:res=>{}
    }
  },
  methods:{
    handleDialogClose(){
      this.$emit("update:dialogShow",false)
    },
    handleButtonClick(v){
      this.handleFunc(v)
    }
  }
}
</script>

<style lang="scss" slot-scope>

.messageProp{
  top: 120px;
  border-radius: 4px;
  height: 140px;
  .el-dialog__title{
    margin-top: -15px;
    font-size: 18px;
    margin-left: -10px;
    display: flex;
  }
  .el-dialog__headerbtn{
    margin-top: -15px;
    margin-right: -10px;
  }
  .el-dialog__headerbtn i {
    font-size: 20px;
  }
  .axj-dialog{
    margin-top: -25px;
    display: flex;
    flex-flow: column;
    .message{
      padding-left: 40px;
      padding-right: 10px;
      font-size: 14px;
      height: 60px;
    }
    .handle{
      margin-top: 5px;
      display: flex;
      justify-content: flex-end;
      .handleButton{
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/axj-message-prop/index.vue